import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { PlayerPortalsGridPageColumn } from '@r-and-a-shared-ui/common-ui';

export default {
  component: () => PlayerPortalsGridPageColumn,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.GridPageColumn) =>
    kontentAiDataMapping.player_portals_grid_page_column(entry),
};
